import React from 'react';

const ModalEdit = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center mt-20 bg-black bg-opacity-50">
      <div className="bg-white rounded-lg w-full max-w-3xl p-6 relative">
        {/* Close button */}
        <button onClick={onClose} className="absolute top-4 right-4 text-xl">&times;</button>

        {/* Title */}
        <h2 className="text-xl font-bold mb-1">Edit Product</h2>
        <p className="text-sm text-gray-500 mb-4">add your product with required fields</p>

        <div className="grid grid-cols-2 gap-7">
          {/* Product name */}
          <input
            type="text"
            defaultValue="Brand New Fiber Helmet"
            className="border-b border-gray-300 focus:outline-none py-1"
          />

          {/* User name */}
          <input
            type="text"
            defaultValue="Sanjai"
            className="border-b border-gray-300 focus:outline-none py-1"
          />

          {/* Price with currency */}
          <div className="flex items-center gap-2 border-b border-gray-300 py-1">
            <span>₹</span>
            <input
              type="text"
              defaultValue="2000"
              className="flex-1 focus:outline-none"
            />
            <select className="bg-transparent focus:outline-none">
              <option>INR</option>
            </select>
          </div>

          {/* Original price (struck through) */}
          <input
            type="text"
            defaultValue="₹3000"
            className="border-b border-gray-300 focus:outline-none py-1 line-through text-gray-500"
          />

          {/* Discount */}
          <input
            type="text"
            defaultValue="30%"
            className="border-b border-gray-300 focus:outline-none py-1"
          />

          {/* Country with flag */}
          <div className="flex items-center gap-2 border-b border-gray-300 py-1">
            <span>🇮🇳</span>
            <input
              type="text"
              defaultValue="India"
              className="focus:outline-none"
            />
          </div>
        </div>
        <div className=' flex justify-between'>
         <div className="flex gap-6 mt-4">
          <label className="flex items-center gap-1">
            <input type="radio" name="verify" defaultChecked /> Verified
          </label>
          <label className="flex items-center gap-1">
            <input type="radio" name="verify" /> Non Verified
          </label>
        </div>

        {/* Product image upload */}
        <div className="mt-4 ">
          <label className="block text-sm font-medium mb-1">
            Product Images<span className="text-red-500">*</span>
          </label>
          <div className="flex items-center border rounded px-2 py-1">
            <input type="file" className="w-full" />
            <span className="ml-2 text-sm text-gray-500">img.png</span>
          </div>
        </div>
        </div>

        {/* Verified radio */}
       

        {/* Description */}
        <div className="mt-4">
          <textarea
            rows="4"
            defaultValue="Electronics is the study and use of electrical components like transistors, resistors, and usefull products"
            className="w-full border rounded px-3 py-2 focus:outline-none"
          />
        </div>

        {/* Save button */}
        <div className="mt-6 text-right">
          <button className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700">Save</button>
        </div>
      </div>
    </div>
  );
};

export default ModalEdit;